module.exports = __webpack_public_path__ + "img/mvp.3b146a4e.png";